import React from "react";
import PropTypes from "prop-types";
import HeaderTitle from "header/components/title";

const AccountHeaderTitle = () => <HeaderTitle title="Your Account" />;

export default AccountHeaderTitle;
